import Vue from 'vue';
import utilities from '../../api/utilities.js';
import cart from '../../api/cart.js';
import module from '../../api/module.js';

import * as types from '../mutation-types';

import _ from 'lodash';

const STORAGE_KEY = 'MODULE';

// initial state
// shape: [{ id, quantity }]
const state = {
  initialized: false,
  visitor_id: 0,
  affiliate_id: '',
  iframe_id: null,
  active_module: {
    currency: 'TL',
    settings: {
      payment: {
        partial: '',
        coupon: ''
      },
      success: {
        redirect_url: '',
        redirect_delay: '',
        message: ''
      },
      module: {
        default_language_front: 'en',
        show_banner: true,
        show_language: true,
        show_sort: true,
        show_category: true,
      },
      mail: {

      },
      design: {

      }
    },
  },
  active_gateway: {},
  fields: {}, // these are the fields that are remembered via localStorage,
  field_errors: [],
  gateway_type: '',
  selected_installment: {
    installment: 1,
    multiplier: 1,
  },
  selected_partial: '',
  selected_category: '',
  selected_sort_order: '',
};

// getters
const getters = {
  initialized: (state) => state.initialized,
  // checkoutStatus: state => state.checkoutStatus
  visitor_id: (state) => {
    return state.visitor_id;
  },
  active_module: (state) => state.active_module,
  active_gateway: (state) => state.active_gateway,
  fields: (state) => state.fields,
  field_errors: (state) => state.field_errors,
  selected_installment: (state) => state.selected_installment,
  selected_partial: (state) => state.selected_partial,
  selected_category: (state) => state.selected_category,
  selected_sort_order: (state) => state.selected_sort_order,
};

// actions
const actions = {

  initialize_data ({ commit, state, dispatch }, to) {
    // init categories
    let p1 = new Promise((resolve, reject) => {
      dispatch('init_categories', {
        module_id: to.params.module_id
      }).then(resp => resolve());
    });

    // init module
    let p2 = new Promise((resolve, reject) => {
      dispatch('init_module',
        to.params.module_id
      ).then(resp => resolve());
    });

    // list products
    let p3 = new Promise((resolve, reject) => {
      dispatch('list_products', {
        module_id: to.params.module_id,
        category_id: to.query.category_id
      }).then(resp => resolve());
    });

    // init vendor_id
    let p4 = new Promise((resolve, reject) => {
      dispatch('init_vendor_id',
        to.params.vendor_id
      ).then(resp => resolve());
    });

    // init visitor id
    let p5 = new Promise((resolve, reject) => {
      dispatch('init_visitor_id',
        to.params.module_id
      ).then(resp => resolve());
    });

    // init cart
    let p6 = new Promise((resolve, reject) => {
      dispatch('init_cart',
        to.params.module_id
      ).then(resp => resolve());
    });

    // init product info
    let p7 = new Promise((resolve, reject) => {
      if (!to.params.product_id) {
        return resolve();
      }
      console.log('product_info');
      dispatch('info_product', {
        module_id: to.params.module_id,
        product_id: to.params.product_id
      }).then(resp => resolve());
    });

    // let p8 = new Promise((resolve, reject) => {
    //   dispatch('init_url',
    //     {
    //       module_id: to.params.module_id,
    //       url: 'window.parent.location.href',
    //     }
    //   ).then(resp => resolve());
    // });

    return Promise.all([p1, p2, p3, p4, p5, p6, p7]).then(values => {
      commit(types.SET_INITIALIZED, true);
    });
  },

  checkout ({ commit, state }, products) {
    // const savedCartItems = [...state.added]
    commit(types.CHECKOUT_REQUEST);
    cart.buyProducts(
      products,
      () => commit(types.CHECKOUT_SUCCESS),
      () => commit(types.CHECKOUT_FAILURE, { })
    );
  },

  init_visitor_id ({ commit, state }, module_id) {
    /* eslint-disable no-undef */
    let visitor_id = localStorage.getItem(STORAGE_KEY + '-' + module_id + '-' + 'visitor_id');
    if (visitor_id === null || visitor_id === 'null' || visitor_id === 'undefined' || visitor_id === undefined) {
      module.getVisitorID(
        (response) => {
          visitor_id = response.data.data.visitor_id;
          // if (utilities.isValidResponse(response) === true) {
          // } else {
          //   console.log('problem :(', response);
          // }
          /* eslint-disable no-undef */
          localStorage.setItem(STORAGE_KEY + '-' + module_id + '-' + 'visitor_id', visitor_id);

          commit(types.VISITOR_ID_SET, {
            visitor_id: visitor_id
          });
        },
        (response) => {
          // error on the call.
        }
      );
    } else {
      commit(types.VISITOR_ID_SET, {
        visitor_id: visitor_id
      });
    }
  },

  init_vendor_id ({ commit, state }, vendor_id) {
    if (state.vendor_id !== undefined) {
      return;
    }

    let vendor_id_processed = '';
    if (vendor_id !== undefined) {
      vendor_id_processed = vendor_id;
    }
    commit(types.VENDOR_ID_SET, { vendor_id: vendor_id_processed });
  },

  init_url ({ commit, state }, payload) {
    commit('SET_AFFILIATE', payload.affiliate);

    module.infoUrl(
      {
        module_id: payload.module_id,
        url: payload.url
      },
      (response) => {
      },
      (response) => { }
    );
  },

  init_module ({ commit, state }, module_id) {
    module.infoModule(
      module_id,
      (response) => {
        let module_info = response.data.data;

        Vue.config.lang = module_info.settings.module.default_language_front;

        let fields = {};
        module_info.fields.forEach((field) => {
          fields[ field.name ] = {
            name: field.name,
            title: field.title,
            value: '',
            required: field.required,
          };
        });

        commit(types.MODULE_INIT_SUCCESS, {
          data: module_info,
          fields: fields,
        });

        // Restore field content from localstorage.
        /* eslint-disable no-undef */
        let fieldsLocalstorage = JSON.parse(localStorage.getItem(STORAGE_KEY + '-' + module_id + '-' + 'fields'));
        if (fieldsLocalstorage) {
          Object.keys(fields).forEach((field) => {
            fields[field].value = fieldsLocalstorage[field].value;
            commit(types.MODULE_UPDATE_FORM_FIELD, {
              name: fields[field].name,
              value: fields[field].value,
              title: fields[field].title,
            });
          });
        }
      },
      (response) => {
        // debugger;
        // commit(types.MODULE_INIT_FAILURE);
      }
    );
  },

  select_payment_method ({commit, state}, parameters) {
    commit(types.MODULE_SELECT_PAYMENT_METHOD, parameters.gateway_type);
  },

  select_installment ({commit, state}, parameters) {
    commit(types.MODULE_SELECT_INSTALLMENT, parameters.installment);
  },

  select_partial ({commit, state}, parameters) {
    commit(types.MODULE_SELECT_PARTIAL, parameters);
  },

  select_category_id ({commit, state}, parameters) {
    commit(types.CATEGORY_SET_SELECTED_CATEGORY, parameters);
  },

  select_sort_order ({commit, state}, parameters) {
    commit(types.SORT_ORDER_SET_ORDER, parameters);
  },

  update_form_field ({ commit, state }, parameters) {
    commit(types.MODULE_UPDATE_FORM_FIELD, parameters);
  },

  make_payment ({commit, state, rootState}) {
    return new Promise((resolve, reject) => {
      let error_items = [];
      Object.keys(state.fields).forEach((field) => {
        console.log('Field', state.fields[field]);
        let tempField = state.fields[field];
        if (tempField.required === 'x' && tempField.value === '') {
          error_items.push(state.fields[field]);
        }
      });

      commit(types.FIELDS_SET_ERROR, error_items);
      if (error_items.length > 0) {
        // trigger error action
        return;
      }

      // debugger;
      // TODO: We may need to change the logic here because gateways like Paylike are not really redirecting anywhere.

      module.redirectPayment(rootState.Module.active_module.module_id, rootState.Module.visitor_id, rootState.Module.gateway_type, rootState.Module.selected_installment.installment, rootState.Module.selected_installment.multiplier, rootState.Module.selected_partial, rootState.Module.fields, rootState.Module.vendor_id, rootState.Module.affiliate_id, rootState.Cart.selected_shipping.shipping_id, (response) => {
        /**
         * License check
         */
        if (response.data.status === 'ERROR') {
          switch (response.data.type) {
            case 'LICENSE':
              window.alert(Vue.t('errors.license'));
              break;

            default:
              window.alert(Vue.t('errors.unexpected'));
          }

          return;
        }

        switch (state.gateway_type) {
          case 'GARANTI_OOS':
          case 'ISBANK_OOS':
          case 'MONEY_ORDER':
          case 'PAYPAL_STANDARD':
          case 'QNBFINANSBANK_OOS':
          case 'YKB_OOS':
            utilities.postRedirect(response.data.data.data, response.data.data.post_url);
            break;

          case 'IYZICO_FORM':
            let status = response.data.data.status;
            if (status === 'ERROR') {
              // TODO: Display alert.
              alert(response.data.data.message);
            } else {
              window.location = response.data.data.redirect_url;
            }
            break;

          case 'VAKIFBANK_OOS':
            window.location = response.data.data.redirect_url;
            break;

          case 'PAYTR':
            window.parent.location.href = response.data.data.redirect_url;
            break;

          default:
            console.error('Unknown payment type:', state.gateway_type);
        }
        resolve();
      }, (error) => {
        reject(error.response.data);
      });
    });
  },
};

// mutations
const mutations = {
  [types.SET_INITIALIZED] (state, value) {
    state.initialized = value;
  },

  [types.SET_AFFILIATE] (state, value) {
    state.affiliate_id = value;
  },

  [types.SET_IFRAME_ID] (state, value) {
    state.iframe_id = value;
  },

  [types.VENDOR_ID_SET] (state, parameters) {
    Vue.set(state, 'vendor_id', parameters.vendor_id);
  },

  [types.VISITOR_ID_SET] (state, parameters) {
    Vue.set(state, 'visitor_id', parameters.visitor_id);
  },

  [types.ADD_TO_CART] (state, { id }) {
    state.lastCheckout = null;
    const record = state.added.find(p => p.id === id);
    if (!record) {
      state.added.push({
        id,
        quantity: 1
      });
    } else {
      record.quantity++;
    }
  },

  [types.MODULE_INIT_SUCCESS] (state, parameters) {
    let active_module = Object.assign({}, parameters.data);

    // Remove disabled gateways before adding to store
    active_module.gateways.forEach((gateway, counter) => {
      if (gateway.disabled === 'x') {
        active_module.gateways.splice(counter, 1);
      }
    });

    active_module.fields.forEach((field) => {
      field.value = '';
    });

    Vue.set(state, 'active_module', active_module);
    Vue.set(state, 'fields', parameters.fields);
  },

  [types.CHECKOUT_REQUEST] (state) {
    // clear cart
    state.added = [];
    state.checkoutStatus = null;
  },

  [types.CHECKOUT_SUCCESS] (state) {
    state.checkoutStatus = 'successful';
  },

  [types.CHECKOUT_FAILURE] (state, { savedCartItems }) {
    // rollback to the cart saved before sending the request
    state.added = savedCartItems;
    state.checkoutStatus = 'failed';
  },

  [types.MODULE_SELECT_PAYMENT_METHOD] (state, data) {
    state.active_module.gateways.forEach((gateway) => {
      if (gateway.type === data) {
        Vue.set(state, 'active_gateway', gateway);
        Vue.set(state, 'gateway_type', data);
      }
    });
  },

  [types.MODULE_SELECT_INSTALLMENT] (state, installment) {
    Vue.set(state, 'selected_installment', {
      installment: installment,
      multiplier: state.active_gateway.installments[installment]
    });
  },

  [types.MODULE_SELECT_PARTIAL] (state, data) {
    console.log('MODULE_SELECT_PARTIAL', data);
    let value = '';
    if (state.selected_partial === 'x') {
      value = '';
    } else {
      value = 'x';
    }
    Vue.set(state, 'selected_partial', value);
  },

  [types.CATEGORY_SET_SELECTED_CATEGORY] (state, parameters) {
    Vue.set(state, 'selected_category', parameters.category_id);
  },

  [types.SORT_ORDER_SET_ORDER] (state, parameters) {
    Vue.set(state, 'selected_sort_order', parameters.sort_order);
  },

  [types.MODULE_UPDATE_FORM_FIELD] (state, parameters) {
    let fields = _.cloneDeep(state.fields);
    if (_.isUndefined(fields)) {
      fields = {};
    }

    state.active_module.fields.forEach((field) => {
      if (fields[field.name] === undefined) {
        fields[field.name] = {
          name: field.name,
          title: field.title,
          value: ''
        };
      } else {
        fields[field.name].title = field.title;
      }
    });

    Object.keys(fields).forEach((field) => {
      if (fields[field].name === parameters.name) {
        fields[field].value = parameters.value;
      }
    });

    // Object.assign(fields, { [parameters.name]: { name: parameters.name, value: parameters.value } });
    /* eslint-disable no-undef */
    localStorage.setItem(STORAGE_KEY + '-' + state.active_module.module_id + '-' + 'fields', JSON.stringify(fields));
    Vue.set(state, 'fields', fields);
  },
  [types.FIELDS_SET_ERROR] (state, field_errors) {
    Vue.set(state, 'field_errors', field_errors);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Module.js